import React, { useEffect } from 'react';
import { useTranslation } from '../../hooks/useTranslation';

export default function SuccessModal({ open, onClose }) {
  const { t } = useTranslation();
  // Lock body scroll while the modal is open
  useEffect(() => {
    const prev = document.body.style.overflow;
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = prev || '';
    }
    return () => {
      document.body.style.overflow = prev || '';
    };
  }, [open]);
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div className="relative bg-white rounded-[16px] shadow-[0px_20px_25px_-5px_#0000001A] border border-[#E6E6E6] w-[90%] max-w-[440px] p-6 text-center z-50">
        <div className="flex justify-center mb-3">
         <img src="/success.svg" alt="" />
        </div>
        <h3 className="text-[#151515] font-[600] text-[18px]  mb-2">
          {t('registration.successModal.title')}
        </h3>
        <p className="text-[#495057] text-[14px]   leading-6 mb-3">
          {t('registration.successModal.thanks')}
        </p>
        <p className="text-[#495057] text-[14px]   leading-6 mb-4">
          {t('registration.successModal.review')}
        </p>

        <p className="text-[#5D4A9D] font-[500] md:text-[13px] text-[11px] mb-2">
          {t('registration.successModal.followUs')}
        </p>
        <div className="flex items-center justify-center gap-4 mb-5">
          <a href="https://www.instagram.com/hobbystation.sa/#" target="_blank" rel="noreferrer" className="text-[#5D4A9D]">
            <img src="/instagram.svg" alt="" />
          </a>
          <a href="https://www.tiktok.com/@hobbystation.sa" target="_blank" rel="noreferrer" className="text-[#5D4A9D]">
            <img src="/ticktok.svg" alt="" />
          </a>
          <a href="https://www.snapchat.com/@hobbystation0?invite_id=9k5WL0qs&locale=ar_SA%40calendar%3Dgregorian&share_id=UGw8n8YPQOyfoQxMdJ_pbg&sid=0a1d01ce8f2f494db8c0e202a83ed763" target="_blank" rel="noreferrer" className="text-[#5D4A9D]">
            <img src="/snap.svg" alt="" />
          </a>
          <a href="https://www.linkedin.com/company/hobbystation0/posts/?feedView=all" target="_blank" rel="noreferrer" className="text-[#5D4A9D]">
            <img src="/linkedin.svg" alt="" />
          </a>
        </div>

        <button
          onClick={onClose}
          className="px-4 py-2 max-w-[190px] rounded-[8px] bg-[#5D4A9D] text-white font-[500] text-[16px]  w-full"
        >
          {t('registration.successModal.done')}
        </button>
      </div>
    </div>
  );
}